import './style.css';
import { Col, Row } from 'react-bootstrap';
export const RowItens = ({ left, right }: { left: JSX.Element, right: JSX.Element, font: number }) => {
    return <Row className={`servicio2`}>
        <Col md={6} className='p-2'>{left}</Col>
        <Col md={6} className='p-2'>{right}</Col>
    </Row>
}